import React from "react";
import Modal from "react-bootstrap/Modal";
import styled from "styled-components";
import { Button } from "react-bootstrap";
import { useTranslation, Trans } from "react-i18next";
import { LessonAward } from "../common/api";
import { LessonImage } from "../common/LessonImage";

const AWARD_IMAGE_MODAL_SIZE = 200;

export const STICKER_PLACEHOLDER_URL = `${process.env.PUBLIC_URL}/profile/sticker-placeholder.svg`;

const AwardButton = styled.button`
  aspect-ratio: 1 / 1;
  padding: 0;
  background-color: transparent;
  border: none;

  img {
    object-fit: contain;
    filter: drop-shadow(1px 2px 0 rgba(0, 0, 0, 0.25));
  }
`;

const ImageBlock = styled.div`
  width: ${AWARD_IMAGE_MODAL_SIZE}px;
  aspect-ratio: 1 / 1;
  margin: auto;
  display: flex;
  justify-content: center;
  overflow: hidden;
`;

export const AwardSticker = ({
  award,
  onClick,
}: {
  award: LessonAward;
  onClick: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <AwardButton onClick={onClick}>
      {award.image_url && (
        <LessonImage
          lazy
          thumbSize="small"
          url={award.image_url}
          alt={t("award_content_description", {
            name: award.name,
            description: award.description,
          })}
        />
      )}
    </AwardButton>
  );
};

export const AwardModal = ({
  award,
  onClose,
}: {
  award: LessonAward | null;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <Modal show={award !== null} onHide={onClose}>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        {award !== null && (
          <>
            <ImageBlock>
              {award.image_url && (
                <LessonImage
                  style={{ aspectRatio: "1 / 1" }}
                  thumbSize="default"
                  url={award.image_url}
                  alt={t("award_content_description", {
                    name: award.name,
                    description: award.description,
                  })}
                />
              )}
            </ImageBlock>
            <div className="text-center my-5">
              <Trans
                t={t}
                i18nKey="award_details"
                values={{
                  name: award.name,
                  description: award.description,
                }}
              />
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t("awards_close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
